import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ImageViewerComponent } from './image-viewer.component';
import { ImageViewerService }   from './image-viewer.service';

@NgModule({
  declarations: [
    ImageViewerComponent
  ],
  entryComponents: [
    ImageViewerComponent
  ],
  exports: [
    ImageViewerComponent
  ],
  providers: [
    ImageViewerService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ImageViewModule {}
